
import React, { useRef, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import useMounted from '../../hooks/useMounted';


import SimpleReactValidator from 'simple-react-validator';
import { post } from '../../helpers/api_helper';
import { POST_GET_CATEGORY_DETAIL, POST_ADD_EDIT_CATEGORY, POST_GET_CATEGORY_FORM_OPTION } from '../../helpers/url_helper';
import { toast } from 'react-toastify';
import Loader from '../../components/Loader';

const Item = (props) => {
    const navigate = useNavigate();

    const [isLoader, setLoader] = useState(0);

    const simpleValidator = useRef(new SimpleReactValidator());
    const [ButtonDisabled, SetButtonDisabled] = useState(false);
    const [form_inputs, setInputs] = useState({ categoryId: 0, parentId: 0, categoryName: '', categoryImageUrl : '', image : '',isPopular : 0 });
    const [categoryList, setCategoryList] = useState([]);
    const [, forceUpdate] = useState();

    const { id } = useParams()

    useMounted(() => {
        async function get_detaile() {
            var res_data = await post(POST_GET_CATEGORY_FORM_OPTION, { 'id': (id) ? id : 0 });
            if (res_data.status) {
                setCategoryList(res_data.data.category_list);
            }
            if (id) {
                var res_data1 = await post(POST_GET_CATEGORY_DETAIL, { 'id': id });
                if (res_data1.status) {
                    setInputs(res_data1.data.categoryDetail);
                } else {
                    toast.error(res_data1.message);
                    navigate("/");
                }
            }
            setLoader(1)
        }
        get_detaile();
    }, [])

    // form submit event
    const handleSubmit = async (event) => {
        event.preventDefault();
        const formValid = simpleValidator.current.allValid()
        if (!formValid) {
            simpleValidator.current.showMessages(true);
            forceUpdate(1);
        } else {
            SetButtonDisabled(true);
            var res_data = await post(POST_ADD_EDIT_CATEGORY, form_inputs, {});
            if (res_data.status) {
                toast(res_data.message);
                navigate("/categories");
            } else {
                toast.error(res_data.message);
            }
            SetButtonDisabled(false);
        }
    }

    // input text change handler
    const handleInputChange = (event) => {
        event.persist();
        if (event.target.name === 'image') {
            var file_extension = event.target.files[0].name.split('.').pop();
            var file_size = event.target.files[0].size;
            file_size = (file_size / 1024 / 1024).toFixed(1);

            var extension = ['png','jpg', 'jpeg'];
            if (!extension.includes(file_extension.toLowerCase())) {
                toast.error('Allow only file png, jpg and jpeg.');
                event.target.value = null;
                return false;
            }

            if (file_size > 1) {
                toast.error('Max File size Allowed 1Mb.');
                event.target.value = null;
                return false;
            }

            var file = event.target.files[0];
            var reader = new FileReader();
            reader.onload = function () {
                setInputs(inputs => ({ ...form_inputs, [event.target.name]: reader.result }));
            }
            reader.readAsDataURL(file);

        } else if(event.target.name === 'isPopular') {
            setInputs(inputs => ({ ...form_inputs, [event.target.name]: (event.target.checked)? 1 : 0 }));
        } else {
            setInputs(inputs => ({ ...form_inputs, [event.target.name]: event.target.value }));
        }
    }



    if (!isLoader) {
        return (<Loader />);
    }
    return (
        <>
            <div className='row'>
                <div className="col-md-6">
                    <div className="card mb-4">
                        <h5 className="card-header">Category</h5>
                        <div className="card-body">
                            <form className="av-invalid" onSubmit={handleSubmit}>
                                <div className='mb-3'>
                                    <label className="form-label text-capitalize">Select Parent Category</label>
                                    <select name="parentId" value={form_inputs.parentId} onChange={handleInputChange} className="form-control" >
                                        <option value="">Select Category</option>
                                        {categoryList && categoryList.map(({ categoryId, categoryName }) => (
                                            <option key={categoryId} value={categoryId}>
                                                {categoryName}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className='mb-3'>
                                    <label className="form-label text-capitalize">Name *</label>
                                    <input name="categoryName" value={form_inputs.categoryName} onChange={handleInputChange} className="form-control" placeholder="Enter Name" type="text" />
                                    {simpleValidator.current.message('name', form_inputs.categoryName, 'required')}
                                </div>
                                <div className='mb-3 row'>
                                    <div className='col-sm-8'>
                                        <label className="form-label text-capitalize">Category Image <small>600px X 600px</small> </label>
                                        <input name="image" type="file" onChange={handleInputChange} className="form-control" />
                                    </div>
                                    <div className='col-sm-4'>
                                        <img src={form_inputs.categoryImageUrl} style={{'maxWidth' : '200px', 'width' : '100%'}} alt='category' />
                                    </div>
                                </div>
                                <div className='mb-3'>
                                    <div className="form-check form-switch mb-2">
                                        <label className="form-check-label" htmlFor="isPopular">Is Popular Category</label>
                                        <input className="form-check-input" defaultChecked={parseInt(form_inputs.isPopular)} name='isPopular' onChange={handleInputChange} type="checkbox" id="isPopular" />
                                    </div>
                                </div>

                                <div className='text-center'>
                                    <button disabled={ButtonDisabled} className="btn btn-primary pt-2 pb-2">
                                        {ButtonDisabled && <i className="fa fa-spinner me-2 fa-spin"></i>} Save
                                    </button>
                                    <Link to="/categories" className="btn btn-danger ms-3"> Cancel</Link>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Item;